import { arrayMove } from "@dnd-kit/sortable"
import { GetNewOrderEntry, getNewQuestion } from "./elementHelpers"

export function moveElementQuestionFromQuestionOrderToGroup(
  questionOrders,
  questionOrderId,
  questionGroupId,
  questionId,
  overQuestionId,
  type
) {
  let updatedQuestionOrders = JSON.parse(JSON.stringify(questionOrders))

  //find the existing indexes
  const questionOrderIndex = updatedQuestionOrders.findIndex(
    (order) => order.id === questionOrderId
  )
  const questionGroupOrderIndex = updatedQuestionOrders.findIndex(
    (order) => order.questionGroup?.id === questionGroupId
  )

  //Stage the objects
  let questionOrder = updatedQuestionOrders[questionOrderIndex]
  let question = questionOrder?.question
    ? questionOrder?.question
    : questionOrder?.questionGroup?.questions.find(
        (existingQuestion) => existingQuestion.id === questionId
      )
  let questionGroupOrder = updatedQuestionOrders[questionGroupOrderIndex]
  let questionGroup = questionGroupOrder.questionGroup

  let groupContainsQuestion = questionGroup.questions.some(
    (existingQuestions) => existingQuestions.id === question?.id
  )

  if (questionOrder?.questionGroup) {
    question = questionOrder.questionGroup.questions.find(
      (question) => question.id === questionId
    )
  }

  if (!questionOrder) {
    if (!groupContainsQuestion) {
      //The question is not yet in a questionORder, just add a new question to the group
      question = getNewQuestion(type)
      question.groupOrder = questionGroup.questions.length + 1
      questionGroup = {
        ...questionGroup,
        questions: [...questionGroup.questions, question],
      }

      updatedQuestionOrders[questionGroupOrderIndex].questionGroup =
        questionGroup
    }
  } else {
    //Add the question to the group if it is not yet there
    if (!groupContainsQuestion) {
      question.groupOrder = questionGroup.questions.length + 1
      questionGroup.questions = [...questionGroup.questions, question]

      updatedQuestionOrders[questionGroupOrderIndex].questionGroup =
        questionGroup
    }

    //There is already a question created on a question order. Remove the question order entry
    if (questionOrder.id !== questionGroupOrder.id) {
      //Remove the questionOrder from the list
      updatedQuestionOrders = updatedQuestionOrders.map((order) => {
        if (order.id !== questionOrderId) {
          return order
        } else {
          return { ...order, isDeleted: true }
        }
      })
    }
  }

  if (overQuestionId && overQuestionId !== question.id) {
    updatedQuestionOrders[questionGroupOrderIndex].questionGroup.questions =
      MoveOrderEntryToNewIndex(
        updatedQuestionOrders[questionGroupOrderIndex].questionGroup.questions,
        overQuestionId,
        question.id
      )
  }

  return {
    questionOrders: updatedQuestionOrders,
    questionOrderId: questionGroupOrder.id,
    questionGroupId: questionGroup.id,
    questionId: question.id,
  }
}

export function moveElementQuestionFromGroupToQuestionOrder(
  questionOrders,
  questionGroupOrderId, //This is the ID of the questionOrder that holds the group
  questionId
) {
  let updatedQuestionOrders = [...questionOrders]

  //Find the existing indexes
  const questionOrderIndex = updatedQuestionOrders.findIndex(
    (order) => order.id === questionGroupOrderId
  )

  const questionIndex = updatedQuestionOrders[
    questionOrderIndex
  ].questionGroup.questions.findIndex((question) => question.id === questionId)

  //Stage the objects
  const group = updatedQuestionOrders[questionOrderIndex].questionGroup
  const question = group.questions[questionIndex]

  //Remove the question from the group
  group.questions = group.questions.filter(
    (question) => question.id !== questionId
  )
  updatedQuestionOrders[questionOrderIndex].questionGroup = group

  //Add new questionOrder entry
  let newQuestionOrder = GetNewOrderEntry(
    question.type,
    updatedQuestionOrders.length + 1
  )
  newQuestionOrder.question = question

  updatedQuestionOrders = [...updatedQuestionOrders, newQuestionOrder]
  updatedQuestionOrders = updateOrdering(updatedQuestionOrders)

  return {
    questionOrders: updatedQuestionOrders,
    newQuestionOrderId: newQuestionOrder.id,
  }
}

export function updateOrdering(questionOrderList) {
  return questionOrderList.map((entry, index) => {
    if (entry.groupOrder) {
      return { ...entry, groupOrder: index + 1 }
    } else {
      return { ...entry, orderNumber: index + 1 }
    }
  })
}

export function MoveOrderEntryToNewIndex(array, targetId, moveToId) {
  const activeIndex = array.findIndex((order) => order.id === targetId)
  const overIndex = array.findIndex((order) => order.id === moveToId)

  let newOrder = arrayMove(array, activeIndex, overIndex)

  return updateOrdering(newOrder)
}
